import React from "react";

export const FilterIconWithoutBadge = () => {
  return (
    <svg width="25" height="28" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      
      <path 
        id="Layer_1" stroke="white" strokeLinecap="round" strokeLinejoin="round" 
        strokeMiterlimit="5" strokeWidth="2" opacity={0.75}
        d="M4.8772,4.9216l6.8975,9.1338c0.8371,1.1085,1.2899,2.4597,1.2899,3.8487v10.4141
        c0,0.3546,0.4113,0.5507,0.6868,0.3273l3.371-2.733c0.5032-0.408,0.7955-1.0212,0.7955-1.669v-6.1332
        c0-1.515,0.5386-2.9807,1.5196-4.1352l7.655-9.0095c0.542-0.6379,0.0886-1.618-0.7484-1.618H5.6609
        C4.8502,3.3477,4.3886,4.2746,4.8772,4.9216z">
      </path>
    </svg>
  );
};

export default FilterIconWithoutBadge;
